import { useMutation } from "@apollo/client";
import { useI18n } from "providers/I18nProvider";
import { gql } from "types";

const SIGN_UP = gql(/* GraphQL */ `
  mutation RegisterUser(
    $email: String!
    $password: String!
    $isEmployee: Boolean!
    $invitationId: String
  ) {
    registerUser(
      email: $email
      password: $password
      isEmployee: $isEmployee
      invitationId: $invitationId
    ) {
      accessToken
      refreshToken
    }
  }
`);

export const useSignUp = () => {
  const { language } = useI18n();
  const [signUp, { error, loading }] = useMutation(SIGN_UP, {
    context: {
      headers: {
        "Accept-Language": language,
      },
    },
  });

  return { signUp, error, loading };
};
